import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ReleaseBlocker } from '../../../models/release-results.model';
import { ReportPlanErgebnis, ReportStatus } from '../../../models/release-report.model';

@Component({
  selector: 'app-report-doc-status',
  imports: [TranslatePipe],
  templateUrl: './report-doc-status.component.html',
  styleUrl: './report-doc-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportDocStatusComponent {
  readonly status = input.required<ReportStatus>();
  readonly scopeLabel = input.required<string>();

  protected planProgress(plan: ReportPlanErgebnis): number {
    return plan.gesamt ? Math.round(((plan.gesamt - plan.offen) / plan.gesamt) * 100) : 0;
  }

  protected progress(ausgefuehrt: number, gesamt: number): number {
    return gesamt ? Math.round((ausgefuehrt / gesamt) * 100) : 0;
  }

  protected blockerPlans(blocker: ReleaseBlocker): string {
    return blocker.plaene?.length ? blocker.plaene.map((p) => p.key ?? '—').join(', ') : (blocker.planKey ?? '—');
  }
}
